// extracted by mini-css-extract-plugin
export default {"blockHtml":"m4vdbwDmgHtvt3tGhhdn","title":"dF9RsUxAiGXa5u8BtJoL"};